var WMTT = WMTT || {};

WMTT.Main = function () {
  this.socialConnectUrl = {};
  this.authNextUrl = document.location.href;
  this.googleRecaptchaPublicKey = '';
  this.accountCookieConsent = null;
  this.accountCookieConsentSaveUrl = '';
  this.translations = [];
  this.cookiesUrl = '';
  this.authenticated = false;
  
  window.WMTT_Main = this;
};


WMTT.Main.prototype.socialConnect = function(provider, nexturl) {
  document.location = this.socialConnectUrl[provider] + "?nexturl=" + encodeURIComponent(nexturl);
};


WMTT.Main.prototype.openModalLogin = function(nexturl) {
  this.authNextUrl = nexturl;
  $('#modal-login .modal-dialog').removeClass('modal-dialog--register');
  $('#modal-login .modal-dialog').removeClass('modal-dialog--forgotten-password');

  if((window.self !== window.top) && (typeof document.requestStorageAccess == "function")) {
    if(typeof URL == "function") {
      var url = new URL(document.location.href);
      url.searchParams.delete('webview');
      url.searchParams.set('open-login', '1');
      url.searchParams.set('nexturl', nexturl);
      url = url.toString();
    }
    else {
      var url = document.location.href.replace("webview=1", "");
    }
    window.open(url, "_blank");
    /*document.requestStorageAccess().then(
      function () {
        // Storage access was granted.
        $('#modal-login').modal();
      },
      function () {
        // Storage access was denied.
        window.open(document.location, "_blank");
      }
    );*/
  }
  else
    $('#modal-login').modal();
};


WMTT.Main.prototype.initLogin = function() {
  var that = this;

  /* modal display */
  $('.login-button').click(function(e) {
    e.preventDefault();
    $('#navbar-collapse-1').collapse('hide');
    that.openModalLogin(document.location.href);
  });

  $('.need-auth').attr('rel', ($('.need-auth').attr('rel') ? $('.need-auth').attr('rel') : '') + " webappforceout");
  $('.need-auth').click(function(e) {
    e.preventDefault();
    $('#navbar-collapse-1').collapse('hide');

    var nexturl = $(this).data('nexturl');
    if(!nexturl)
      nexturl = $(this).attr('href');
    that.openModalLogin(nexturl);

    var defaultform = $(this).data('defaultform');
    if(defaultform == "register")
      $('#modal-login .modal-dialog').addClass('modal-dialog--register');
    else if(defaultform == "forgotten-password")
      $('#modal-login .modal-dialog').addClass('modal-dialog--forgotten-password');
  });

  $('#modal-login .forgotten-password').click(function(e) {
    $('#modal-login .forgotten-password-form .step-information').show();
    $('#modal-login .forgotten-password-form .step-finish').hide();
    $('#modal-login #forgotten-password-email').val($('#modal-login #login-email').val());
    $('#modal-login .modal-dialog').addClass('modal-dialog--forgotten-password');
  });

  $('#modal-login .register').click(function(e) {
    e.preventDefault();
    $('#modal-login #register-email').val($('#modal-login #login-email').val());
    $('#modal-login .modal-dialog').addClass('modal-dialog--register');
  });
  
  $('#modal-login .back').click(function(e) {
    e.preventDefault();
    $('#modal-login .modal-dialog').removeClass('modal-dialog--register');
    $('#modal-login .modal-dialog').removeClass('modal-dialog--forgotten-password');
  });

  /*login form */
  $('#modal-login .login-form').submit(function() {
    var $form = $(this);
    $form.find('.error').html('').hide();

    var email = $form.find('input[name=email]').val();
    var password = $form.find('input[name=password]').val();

    if(email == '' || password == '') return false;

    var options = {
      dataType: 'json',
      success: function (response, statusText, xhr, $form) {
        if(response.success)
          document.location = that.authNextUrl;
        else
          $form.find('.error').text(response.message).show();
      }
    };
    
    $form.ajaxSubmit(options);

    return false;
  });

  /*forgotten password form */
  $('#modal-login .forgotten-password-form').submit(function() {
    var $form = $(this);
    $form.find('.error').html('').hide();

    var email = $form.find('input[name=email]').val();

    if(email == '') return false;

    grecaptcha.ready(function() {
      grecaptcha.execute(that.googleRecaptchaPublicKey, {action: 'forgotten_password'}).then(function(token) {
        var options = {
          dataType: 'json',
          data: { captchatoken: token },
          success: function (response, statusText, xhr, $form) {
            if(response.success) {
              $form.find('.step-information').hide();
              $form.find('.step-finish').show();
            }
            else
              $form.find('.error').text(response.message).show();
          }
        };

        $form.ajaxSubmit(options);
      });
    });

    return false;
  });

  /*login social */
  $('#modal-login .login-social .facebook-button').click(function() {
    that.socialConnect("facebook", that.authNextUrl);
  });
  $('#modal-login .login-social .google-button').click(function() {
    that.socialConnect("google", that.authNextUrl);
  });

  /*register form */
  $('#modal-login .register-form').submit(function() {
    var $form = $(this);
    $form.find('.error').html('').hide();

    if($form.find('input[name="emailcodesent"]').val() == '0')
      $form.find('.step-information input').each(function() { $(this).data('value', $(this).val()); });

    grecaptcha.ready(function() {
      grecaptcha.execute(that.googleRecaptchaPublicKey, {action: 'register'}).then(function(token) {
        var options = {
          dataType: 'json',
          data: { captchatoken: token },
          success: function (response, statusText, xhr, $form) {
            if(response.success) {
              if(response.registered)
                document.location = that.authNextUrl;
              else {
                $form.find('input[name="emailcodesent"]').val("1");
                $form.find('.step-information').slideUp();
                $form.find('.step-emailcode').slideDown({complete: function() {
                  $form.find('.step-information input').each(function() { $(this).val($(this).data('value')); });
                }});
                $form.find('.submit-button').hide();
                $form.find('.finish-button').show();
              }
            }
            else
              $form.find('.error').text(response.message).show();
          }
        };
    
        $form.ajaxSubmit(options);
      });
    });

    

    return false;
  });

};



WMTT.Main.prototype.run = function() {
  var that = this;

  if(!navigator.cookieEnabled) {
    $('#modal-login .modal-body').text("Cookies are disabled on your device, you must enable them to use this website.")
    if(window.self == window.top)
      $('#modal-login').modal();
  }

  this.initialiseCookieConsent();
  this.customizeCookieConsent();

  $(window).scroll(function() {
    if($(window).scrollTop() > 0) {
      $('body').removeClass('unscrolled');
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
      $('body').addClass('unscrolled');
    }
  });
  $(window).scroll();

  if(!is_touch_device()) {
    $('a, .link').mouseover(function(){
      $(this).addClass('hover');
    });
    $('a, .link').mouseout(function(){
      $(this).removeClass('hover');
    });
  }

  if(window.self !== window.top)
    $('body').addClass('inside-iframe');

  function resizeMain() {
    var h = $(window).height() - $('.footer').outerHeight();
    $('#main').css({'min-height': h});
  }

  resizeMain();
  $(window).on("resize", resizeMain);

  if(!this.authenticated)
    this.initLogin();

  if(typeof URL == "function") {
    var url = new URL(document.location.href);
    if(url.searchParams.get('open-login') == '1') {
      var nexturl = url.searchParams.get('nexturl');
      if(this.authenticated)
        document.location = nexturl;
      else
        this.openModalLogin(nexturl);
    }
  }
};

WMTT.Main.prototype.initialiseCookieConsent = function() {

  var that = this;
  
  if(window.localStorage) {
    var maxDays = 365; // reset when storage is more than this
    var now = new Date().getTime();
    var setupTime = window.localStorage.getItem('cookie-consent-date');
    if ((setupTime == null) || ((now - setupTime) > (maxDays*24*60*60*1000))) {
      window.localStorage.removeItem('cookie-consent-preferences');
    }
  }

  var options = {
    append: false,
    cookies: [
      {
        id: 'mandatory',
        label: this.translations['consent-mandatory-label'],
        description: this.translations['consent-mandatory-description'],
        required: true,
        checked: true,
      },
      {
        id: 'performance',
        label: this.translations['consent-performance-label'],
        description: this.translations['consent-performance-description'],
        required: false,
        checked: true,
      },
      {
        id: 'features',
        label: this.translations['consent-features-label'],
        description: this.translations['consent-features-description'],
        required: false,
        checked: false,
      },
      {
        id: 'marketing',
        label: this.translations['consent-marketing-label'],
        description: this.translations['consent-marketing-description'],
        required: false,
        checked: false,
      },
    ],
    labels: {
      title: this.translations['consent-popin-title'],
      description: this.translations['consent-popin-description'].replace('{{cookiesUrl}}', this.cookiesUrl),
      button: {
        default: this.translations['consent-popin-button-accept-selected'],
        acceptAll: this.translations['consent-popin-button-accept-all'],
      },
    },
  };

  window.cookie_consent = CookieConsent(options);

  window.cookie_consent.on('update', function(cookies) {
    console.log("cookies preferences update", cookies);
    that.saveAccountCookieConsent(cookies);
  });
}

WMTT.Main.prototype.customizeCookieConsent = function() {
  if(!window.cookie_consent)
    return;
  var that = this;
  var $dialog = $(window.cookie_consent.getDialog());
  var $list = $dialog.find('.cookie-consent__tab-list').hide();
  var $originalButton = $dialog.find('.cookie-consent__button').hide();
  var $buttons = $('<div></div>').addClass('buttons').appendTo($dialog.find('form'));
  var $acceptAll = $('<span></span>').addClass('button color-button acceptall-button').text(that.translations['consent-popin-button-accept-all']).appendTo($buttons).on('click', function() {
    $list.find('input').each(function() { this.checked = true; });
    $originalButton.trigger('click');
  });
  var $acceptMandatory = $('<span></span>').addClass('button color-button acceptmandatory-button').html(that.translations['consent-popin-button-accept-mandatory']).appendTo($buttons).on('click', function() {
    $list.find('input').each(function() { this.checked = (this.value == "mandatory"); });
    $originalButton.trigger('click');
  });
  var $customize = $('<span></span>').addClass('button customize-button').text(that.translations['consent-popin-button-customize']).appendTo($buttons).on('click', function() {
    $customize.hide();
    var $acceptCustom = $('<span></span>').addClass('button acceptcustom-button').text(that.translations['consent-popin-button-accept-selected']).appendTo($buttons).on('click', function() {
      $originalButton.trigger('click');
    });
    $list.slideDown();
  });

  if($('body').attr('id') != "page-cookies")
    $dialog.appendTo($('body'));


  $('.cookieconsent-open').on('click', function() {
    if($('.cookie-consent').length == 0)
      $dialog.appendTo($('body'));
    
    window.cookie_consent.showDialog();
    if($customize.filter(":visible").length)
      $customize.trigger('click');
  });

  // save local consent into account if account is empty or different
  var localCookiePreferences = window.cookie_consent.getPreferences();
  if(localCookiePreferences.length > 0) {
    if(this.accountCookieConsent == null)
      this.saveAccountCookieConsent(localCookiePreferences);
    else {
      var difference = false;
      localCookiePreferences.map(function(localValue){
        if(!that.accountCookieConsent.preferences)
          difference = true;
        else {
          that.accountCookieConsent.preferences.map(function(accountValue){
            if((localValue.id == accountValue.id) && (localValue.accepted != accountValue.accepted)) {
              difference = true;
              console.log("cookie consent is different from account : ", localValue, accountValue);
            }
          });
        }
      });

      if(difference)
        this.saveAccountCookieConsent(localCookiePreferences);
    }
  }
}

WMTT.Main.prototype.saveAccountCookieConsent = function(preferences) {
  if(window.localStorage)
    window.localStorage.setItem('cookie-consent-date', new Date().getTime());
  $.ajax({
    url:this.accountCookieConsentSaveUrl,
    type: "POST",
    data: { preferences: JSON.stringify(preferences) }
  });
}




WMTT.cookies = Cookies.withConverter({
  write: function (value) {
    // Encode all characters according to the "encodeURIComponent" spec
    return encodeURIComponent(value)
      // Revert the characters that are unnecessarly encoded but are
      // allowed in a cookie value, except for the plus sign (%2B)
      .replace(/%(23|24|26|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
  },
  read: function (value) {
      return value
        // Decode the plus sign to spaces first, otherwise "legit" encoded pluses
        // will be replaced incorrectly
        .replace(/\+/g, ' ')
        // Decode all characters according to the "encodeURIComponent" spec
        .replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
  }
});


WMTT.getMessageHistory = function(key) {
  var messages = WMTT.cookies.get('messagesHistory');
  if(messages == undefined)
    return null;
  messages = JSON.parse(messages);
  if(typeof messages[key] == "undefined")
    return null;
  return messages[key];
};


WMTT.setMessageHistory = function(key, value) {
  var messages = WMTT.getMessageHistory('messagesHistory');
  if(messages == null)
    messages = {};
  messages[key] = value;
  WMTT.cookies.set('messagesHistory', messages);
};